import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {PopoverCoordinator} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {MoreFiltersDropdown, MoreFiltersDropdownItem} from './moreFiltersDropdown';

/*
 * Props.
 */

export interface MoreFiltersButtonProps {
  dropdownItems: ReadonlyArray<MoreFiltersDropdownItem>;
  onOpen?: Handler;
}

/*
 * Style.
 */

const StyledDropdownContainerDiv = styled.div`
  display: flex;
`;

const StyledButtonContentDiv = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 8px;
  align-items: center;
  padding-left: 3px;
`;

/*
 * Component.
 */

export const MoreFiltersButton: FC<MoreFiltersButtonProps> = (props) => (
  <StyledDropdownContainerDiv>
    <PopoverCoordinator
      renderModal={(popoverProps) => (
        <MoreFiltersDropdown popoverProps={popoverProps} dropdownItems={props.dropdownItems} />
      )}
      renderButton={(isOpen) => renderButton(isOpen)}
      onPopoverToggle={(isOpen) => {
        if (isOpen && props.onOpen) {
          props.onOpen();
        }
      }}
    />
  </StyledDropdownContainerDiv>
);

/*
 * Helpers.
 */

function renderButton(isOpen: boolean) {
  return (
    <Button variant={ButtonVariantsEnum.LINK} size={VisualSizesEnum.SMALL} isOpen={isOpen} hasHover={isOpen}>
      <StyledButtonContentDiv>
        <Trans id="more-filters-dropdown-button">More filters</Trans>
        <Icon name="chevronDownSmall" />
      </StyledButtonContentDiv>
    </Button>
  );
}
